module.exports = __webpack_public_path__ + "static/media/written-numbers.12c08b17.svg";